<template>
<div class="ma-2 ma-md-5 mx-lg-10 mx-xl-auto maxw-1750">
  <div v-if="loadingSession">
    <v-skeleton-loader

              v-for="i in 1"
              :key="i"
              class="pa-md-0 pa-2 ma-md-0 ma-2"
              type="article"
            >
            </v-skeleton-loader>
            </div>
  <div v-if="!loadingSession">
  <v-row justify="left" class="pa-md-0 pa-2 ma-md-0 ma-2">
    <div>
      <span
      class="title font-weight-light
         d-flex flex-nowrap align-center justify-space-between"
       >¡ Hola {{user.middleName }} !
       <span class="caption">{{` (Último acceso: ${ $date("formatTime", lastSession)})`}}</span>
       </span>
    </div>
  </v-row>
  <v-row justify="left" class="pa-md-0 pa-2 ma-md-0 ma-2">
    <div>
      {{`Tienes`}} <b>{{total}}</b> {{`solicitudes pendientes de tu actuación`}}
          <router-link to="/pending">Ver detalles</router-link>
    </div>
  </v-row>
  </div>
  <router-view v-bind="tickets"></router-view>
</div>
</template>

<script>
import Vue from 'vue';
// @ is an alias to /src
import { mapState } from 'vuex';

const getClient = (type) => Vue.api.getClient(type);

export default {
  name: 'RequestPendingWelcome',
  data() {
    return {
      name: false,
      lastSession: [],
      loadingSession: true,
      linkTo: '/pending',
      tickets: [],
      total: 0,
    };
  },
  methods: {
    async loadSession() {
      const sessions = await this.$api.getClient('registerSession').list();
      const { list } = sessions;
      if (list != null && list[0] != null) {
        const sesiones = list[0].sessions;
        this.lastSession = sesiones[0].fecha;
      }
      this.loadingSession = false;
    },
    async search({
      user, start, end, mode,
    }) {
      this.loading = true;
      const response = await getClient('ticket').listPend(user, start, end, mode);
      this.tickets = response.collection_cr.cr;
      this.total = response.collection_cr['@TOTAL_COUNT'];
      this.loading = false;
    },
  },
  async created() {
    this.loadSession();
    await this.search(this.user, 0, 10, 'count');
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
};
</script>
